module.exports = __webpack_public_path__ + "img/corfo.88335104.png";